<template>
  <div class="">
  <!--sticky блок-->
    <div data-uk-sticky="end: !.uk-width-expand; offset: 10">
      <!--блок с фото-->
      <div class="uk-position-relative uk-text-center"
           @mousemove="photoAfterVisible = false; beforeVisible = true; description = false;"
           @mouseleave="photoAfterVisible = true; beforeVisible = false"
           @click="mainPhotoClick('modal_photo_before_zoomed', 'modal_photo_after_zoomed')">
        <!--фото BEFORE-->
        <template v-if="(photoAfterVisible || beforeVisible) && !(withFacesVisible) && !(zoneVisible && !beforeVisible && !withFacesVisible)">
          <!--прилодер между фото для зума-->
          <preloader :is-visible="zoomLoading" style="position: absolute"></preloader>
          <template v-if="modal_photo_before">
            <div class="uk-inline-clip tm-block-img 31" v-show="(beforeVisible || modal_photo_after == null) && !isRedo">
              <inner-image-zoom
                  :src="modal_photo_before"
                  :zoomSrc="modal_photo_before_zoomed_computed"
                  :zoomPreload="true"
                  :className="'main_photo_before_zoomed'"
                  :afterZoomIn="afterZoomInMethod('main_photo_before_zoomed', 'main_photo_after_zoomed')"
                  :afterZoomOut="afterZoomOutMethod('main_photo_before_zoomed', 'main_photo_after_zoomed')"
                  moveType="drag"/>
            </div>
            <div class="uk-inline-clip tm-block-img 33" v-show="(beforeVisible || modal_photo_after == null) && isRedo">
              <img class="main-photo" :src="modal_photo_before" alt="фото Зона" style="min-height: 100%;">
            </div>
          </template>
          <template v-if="modal_photo_after">
            <div class="uk-inline-clip tm-block-img 32" v-show="photoAfterVisible">
              <inner-image-zoom
                  :src="modal_photo_after"
                  :zoomSrc="modal_photo_after_zoomed_computed"
                  :zoomPreload="true"
                  :className="'modal_photo_after_zoomed'"
                  :afterZoomIn="afterZoomInMethod('modal_photo_after_zoomed', 'modal_photo_before_zoomed')"
                  :afterZoomOut="afterZoomOutMethod('modal_photo_after_zoomed', 'modal_photo_before_zoomed')"
                  moveType="drag"/>
            </div>
          </template>
        </template>
      </div>
      <!--блок подписи фото + кнопка скачать before-->
      <div class="uk-grid uk-grid-small uk-flex-middle uk-margin-xsmall-top uk-animation-slide-small-medium 2" data-uk-grid>
        <!--блок подписи фото-->
        <div>
          <div class="tm-left-photo-hover-description">
            <span v-if="isLoading" class="uk-icon uk-spinner uk-margin-small-left uk-light" data-uk-spinner="ratio: 0.7"></span>
            <div class="uk-text-truncate" v-else>
              <template v-if="description && !photoAfterVisible ">
                {{ description }}
              </template>
              <template v-else-if="descriptionComputed">
                {{descriptionComputed}}
              </template>
              <template v-else>
                no data
              </template>
            </div>
          </div>
        </div>
        <!--ZOOM переключатель-->
        <div>
          <ul class="uk-subnav uk-subnav-pill uk-flex-center tm-subnav-small">
            <template v-for="level in zoomLevels">
              <li :class="level == zoomLevel ? 'uk-active': ''" :key="level">
                <a @click="setZoomLevel(level)">{{ level + 'x' }}</a>
              </li>
            </template>
          </ul>
        </div>
        <div class="uk-width-expand"></div>
        <!--сравнение версий-->
        <template v-if="fullImageList.length > 0 && modal_photo_after">
          <div class="tm-compare tm-compare-for-history" style="font-weight: 100" data-ver-compare="for_history">
            <div class="uk-grid uk-grid-small uk-flex-middle" data-uk-grid>
              <div>
                <!--при наведении-->
                <div class="uk-grid uk-grid-small uk-flex-middle" data-uk-grid>
                  <div>
                    <button  @click="photoDownload(selectedOptionSource)" class="uk-button uk-button-success tm-button-compare" :data-uk-tooltip="local_page_keys.button_download + ' - ' + description ">
                      <md-icon class="">file_download</md-icon>
                    </button>
                  </div>
                  <div>
                    <select class="uk-select tm-select-compare" v-model="selectedOptionSource">
                      <option v-for="(item, index) in fullImageList" :key="index" :value="item.value">{{ item.name }}</option>
                    </select>
                    <div class="uk-dropdown tm-dropdown tm-dropdown-top-center" data-uk-dropdown="pos: top-center; offset: 15">
                      {{local_page_keys.description_label_source}}
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <md-icon class="">compare_arrows</md-icon>
              </div>
              <div>
                <!--видимое фото-->
                <div class="uk-grid uk-grid-small uk-flex-middle" data-uk-grid>
                  <div>
                    <select class="uk-select tm-select-compare" v-model="selectedOptionHover">
                      <option v-for="(item, index) in fullImageList" :key="index" :value="item.value">{{ item.name }}</option>
                    </select>
                    <div class="uk-dropdown tm-dropdown tm-dropdown-top-center" data-uk-dropdown="pos: top-center; offset: 15">
                      {{local_page_keys.description_label_on_hover}}
                    </div>
                  </div>
                  <div>
                    <button @click="photoDownload(selectedOptionHover)" class="uk-button uk-button-success tm-button-compare" :data-uk-tooltip="local_page_keys.button_download + ' - ' + tooltipPhotoDownloadHover ">
                      <md-icon class="">file_download</md-icon>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Preloader from "@/pages/Dashboard/Components/Preloader";

import InnerImageZoom from 'vue-inner-image-zoom';

export default {
  name: "PhotoBlockWithZoom",
  props: {
    main_photo_after: {
      type: String,
      default: null,
    },
    main_photo_before: {
      type: String,
      default: null,
    },
    orderId: {
      type: Number,
      default: null,
    },
    fullImageList: {
      type: Array,
      require: true
    },
    zone_photo: {
      require: true,
    },
    afterVisible: {
      type: Boolean,
      require: true
    },
    zoneVisible: {
      type: Boolean,
      require: true
    },
    isOutChat: {
      type: Boolean,
      require: true
    },
  },
  components: {
    Preloader,
    InnerImageZoom
  },
  data() {
    return {
      withFacesVisible: null,
      actionBlockSelects: null,
      modal_photo_before_with_faces: null,
      file: null,
      selectedVersion: null,
      select1: [],
      select_problem: {},
      photoAfterVisible: true,
      beforeVisible: false,
      main_modal_photo_before: '',
      main_modal_photo_after: '',
      local_page_keys: {},
      local_page_keys_functions: {},
      images_types: 'image/jpeg,image/png',
      zoomMode: true,
      zoomLevel: 3,
      zoomLevelOld: 2,
      zoomLevels: [2, 3, 4],
      zoomLoading: false,
      zoomImage: '',
      zoomHighImage: '',
      zoomImageType: 'before',
      zoomType: 'circle',
      description: '',
      functionsClientFile: null,
      modal_photo_before_zoomed: '',
      modal_photo_after_zoomed: '',
      observedZoomedElementStyle: 'top: 0px; left: 0px; transition: opacity 150ms linear 0s, visibility 150ms linear 0s;',
      observedZoomedElementStyleOld: 'top: 0px; left: 0px; transition: opacity 150ms linear 0s, visibility 150ms linear 0s;',
      selectedOptionHover: null,
      selectedOptionSource: null,
      modal_photo_after: this.main_photo_after,
      modal_photo_before: this.main_photo_before,
      isRedo: false
    }
  },
  methods: {
    setZoomLevel(level) {
      if (this.zoomLevels.includes(level)) {
        this.zoomLevelOld = this.zoomLevel;
        this.zoomLevel = level;
        if(this.zoomLevel != this.zoomLevelOld){
          this.zoomLoading = true;
          this.zoomImageRatioErase();
          this.readAndPreviewZoomImage('modal_photo_before');
          this.readAndPreviewZoomImage('modal_photo_after');
          this.changeZoomStyle();
        }
      }
    },
    setZoomImage(type) {
      if (type == 'before') {
        this.zoomImage = this.modal_photo_before;
        this.zoomHighImage = this.modal_photo_before;
        this.zoomImageType = 'before';
      }
      if (type == 'after') {
        this.zoomImage = this.modal_photo_after;
        this.zoomHighImage = this.modal_photo_after;
        this.zoomImageType = 'after';
      }
    },
    setDescription(type, file = null) {
      this.isRedo = false;
      switch (type) {
        case "main_photo_after":
          this.description = this.local_page_keys.description_photo_marking_after;
          break;
        case "main_photo_before":
          this.description = this.local_page_keys.description_photo_marking_before;
          break;
        case "main_photo_before_with_faces":
          this.description = this.local_page_keys.description_photo_marking_face_zone;
          break;
        case "zone_photo":
          this.description = this.parseFileName(file)
          break;
        default:
          this.description = '';
          break;
      }
    },
    parseFileName(url) {
      if (!url)
        return '';

      const foundItem = this.fullImageList.find(item => item.value === url);
      const file  =  foundItem && foundItem.file_name ? foundItem.file_name : '';

      //https://retoucher.app:10001/storage/order_photos/1002825548/order_photo_before_url.jpg
      if (file.includes("order_photo_before_url")) {
        return this.local_page_keys.description_photo_marking_before;
      }
      //https://api.fix-dashboard.vagrant/storage/order_photos/1051611180/order_photo_after_1.jpg
      if (file.includes("order_photo_")) {
        const regex = /order_photo_after_(\d+)/;
        const match = file.match(regex);
        const number = match ? match[1] : '';
        return this.local_page_keys.description_photo_marking_after + ' ' +  number;
      }
      //https://fix-dashboard.vagrant/api/storage/client_files/82925_1687436164.jpg
      if (file.includes("client_files/") && this.functionsClientFile) {
        const functionName = Object.keys(this.functionsClientFile).find(key => this.functionsClientFile[key] === file);

        if (this.local_page_keys_functions[functionName] !== undefined )
          return this.local_page_keys.client_photo_label + ' "' + this.local_page_keys_functions[functionName ] + '"';
        else
          return this.local_page_keys.client_photo_label;
      }
      //https://dl.dropbox.com/s/5nk7v46ejitrjjd/1687299957380971_redo.jpg
      if (file.includes("_redo")) {
        this.isRedo = true;
        return this.local_page_keys.description_photo_return;
      }
      //https://retoucher.app:10001/storage/order_photos/528544183/adminComments20230608145202_528544183.jpeg
      if (file.includes("adminComments")) {
        return this.local_page_keys.description_admin_comment;
      }
    },
    async fetchFunctionsClientFile() {
      await this.$store.dispatch('order/orderFunctionsClientFile', {order_id: Number(this.orderId)})
      let data = this.$store.getters['order/orderFunctionsClientFile'];
      this.functionsClientFile = typeof data !== 'string' ? data : null;
    },
    photoDownload(url) {
      let url_obj = new URL(url);
      // let path = url_obj.pathname;
      //
      // let searchParams = new URLSearchParams(url);
      // let filename = searchParams.has('fn') ? searchParams.get('fn') : path.split('/').pop();
      //
      // if (url_obj.hostname === 'appfls.fixthephoto.com') { // проблема с CORS
      //   url_obj.hostname = 'fdl.retoucher.app';
      // }

      let searchImage = this.fullImageList.find(image => image.value === url);
      let filename = searchImage ? searchImage.file_name : url;

      fetch(url_obj, { method: 'GET' })
          .then(response => response.blob())
          .then(blob => {
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = filename;
            document.body.appendChild(link); // we need to append the element to the dom -> otherwise it will not work in firefox
            link.click();
            link.remove();  //afterwards we remove the element again
            URL.revokeObjectURL(link.href)
          }).catch(e=>alert(e))
    },
    async readAndPreviewZoomImage(main_photo_option){
      let largerImageData; // Declare a global variable
      let _this = this;
      function getFourTimesLargerImageDataFromURL(imageURL, scale = 2) {
        return new Promise((resolve, reject) => {
          //const scale = 2; // Scale factor to make the image four times larger

          const desiredHeight = 900;
          const img = new Image();
          img.crossOrigin = "Anonymous"; // Enable cross-origin requests if necessary

          img.onload = function() {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");
            // Calculate the new dimensions while maintaining the aspect ratio
            let newWidth = img.width * scale;
            let newHeight = img.height * scale;
            if(newHeight > desiredHeight * scale){
              newWidth = newWidth * (desiredHeight * scale / newHeight);
              newHeight = desiredHeight * scale;
              img.width = newWidth;
              img.height = newHeight;
            } else {
              newWidth = newWidth * (desiredHeight * scale / newHeight);
              newHeight = desiredHeight * scale;
              img.width = newWidth;
              img.height = desiredHeight * scale ;
            }
            if(!('zoom_' + scale in window)){
              window['zoom_' + scale] = {};
            }
            if(!('zoom_' + scale in window && 'imgHeight' in window['zoom_' + scale])) {
              window['zoom_' + scale].imgHeight = img.height;
              window['zoom_' + scale].imgWidth = img.width;
            }


            if('zoom_' + scale in window && 'imgHeight' in window['zoom_' + scale]){
              let scaleFactorHeight = window['zoom_' + scale].imgHeight / img.height;
              let scaleFactorWidth = window['zoom_' + scale].imgWidth / img.width;
              newHeight = img.height * scaleFactorHeight;
              newWidth = img.width * scaleFactorWidth;
            }
            canvas.width = newWidth;
            canvas.height = newHeight;

            // Draw the image on the canvas
            ctx.drawImage(img, 0, 0, newWidth, newHeight);

            // Get the larger image data as a data URL

            largerImageData = canvas.toDataURL("image/jpeg"); // Assign to the global variable

            if(largerImageData.length > 6){
              resolve(largerImageData);
            } else {
              largerImageData = imageURL;
              reject(largerImageData);
            }

          };

          img.onerror = function() {
            //console.error("Error loading the image.");
            reject("Failed to fetch the larger image data.");
          };

          img.src = imageURL;
        });
      }

      if(this[main_photo_option] === null && main_photo_option == 'modal_photo_after'){
        this['modal_photo_after'] = this['modal_photo_before'];
        this.modal_photo_before_after_same = true;
      }

      const imageUrl = this[main_photo_option];

      largerImageData = getFourTimesLargerImageDataFromURL(imageUrl, this.zoomLevel)
          .then(largerImage => {
            if (largerImage) {
              // The largerImageData variable contains the Base64-encoded larger image data

              _this[main_photo_option + '_zoomed'] = largerImage;
              //console.log("Larger Image data:", largerImageData);

            } else {
              //console.log("Failed to fetch the larger image data.");
              alert("Failed to fetch the larger image data.")
            }
          })
          .catch(error => {
            //console.error(error);
            _this[main_photo_option + '_zoomed'] = error;
            //alert(JSON.stringify(error));
          });

      //console.log(main_photo_option + '_zoomed', _this[main_photo_option + '_zoomed']);
    },
    changeZoomStyle() {
      const imageContainer = document.querySelector('.' + 'modal_photo_after_zoomed');
      let levelSwitchedOnZoom = false;
      let observedZoomedElementStyle = this.observedZoomedElementStyle;
      if (imageContainer) {
        const childElement = imageContainer.querySelector('.iiz__zoom-img');

        if (
            childElement.classList.contains('iiz__zoom-img') &&
            childElement.classList.contains('iiz__zoom-img--visible')
        ) {
          levelSwitchedOnZoom = true;
        }
      }

      this.$nextTick(() => {

        if(levelSwitchedOnZoom){

          for(const imageContainerClassTo of ['modal_photo_after_zoomed', 'modal_photo_before_zoomed']){
            const imageContainerZoomed = document.querySelector('.' + imageContainerClassTo);
            if (imageContainerZoomed) {
              const imgElementZoomedTo = imageContainerZoomed.querySelector('.iiz__zoom-img');
              const imgElementTo = imageContainerZoomed.querySelector('.iiz__img');
              if (imgElementZoomedTo) {
                if (!imgElementZoomedTo.classList.contains("iiz__zoom-img--visible")) {
                  imgElementZoomedTo.classList.add("iiz__zoom-img--visible");
                }

                let observedZoomedElementStyleObj = this.parseStyleToObject(this.observedZoomedElementStyle);
                let zoomLevel = this.zoomLevel;
                let zoomLevelOld = this.zoomLevelOld;

                let scaleFactor = (zoomLevel / zoomLevelOld);
                let maxTop = (-1) * (zoomLevel - 1) * 900;
                observedZoomedElementStyleObj.top = parseInt(observedZoomedElementStyleObj.top, 10) * scaleFactor;
                if (observedZoomedElementStyleObj.top < maxTop) observedZoomedElementStyleObj.top = maxTop;
                observedZoomedElementStyleObj.top = observedZoomedElementStyleObj.top + 'px';
                observedZoomedElementStyleObj.left = parseInt(observedZoomedElementStyleObj.left, 10) * scaleFactor + 'px';
                this.observedZoomedElementStyle = this.combineObjectToStyle(observedZoomedElementStyleObj);

                imgElementZoomedTo.style = this.observedZoomedElementStyle;
              }
              if (imgElementTo) {
                if (!imgElementTo.classList.contains("iiz__img--hidden")) {
                  imgElementTo.classList.add("iiz__img--hidden");
                }
              }
            }
          }


        }
        this.zoomLoading = false;
      });
    },
    parseStyleToObject(styleString) {
      let styleObject = {};
      let stylePairs = styleString.split(';');
      stylePairs.forEach(function(pair) {
        let parts = pair.trim().split(':');
        if (parts.length === 2) {
          styleObject[parts[0].trim()] = parts[1].trim();
        }
      });
      return styleObject;
    },
    combineObjectToStyle(styleObject) {
      let styleString = '';
      for (let key in styleObject) {
        if (styleObject.hasOwnProperty(key)) {
          styleString += key + ': ' + styleObject[key] + '; ';
        }
      }
      return styleString.trim();
    },
    afterZoomInMethod(imageContainerClassFrom, imageContainerClassTo){
      let _this = this;
      const imageContainerTo = document.querySelector('.' + imageContainerClassTo);
      const imageContainer = document.querySelector('.' + imageContainerClassFrom);

      if (imageContainer) {
        const childElement = imageContainer.querySelector('.iiz__zoom-img');

        if (
            childElement.classList.contains('iiz__zoom-img') &&
            childElement.classList.contains('iiz__zoom-img--visible')
        ) {
          _this.observedZoomedElementStyle = childElement.style.cssText;

          const imageContainerZoomed = document.querySelector('.' + imageContainerClassTo);
          if (imageContainerZoomed) {
            const imgElementZoomedTo = imageContainerZoomed.querySelector('.iiz__zoom-img');
            const imgElementTo = imageContainerZoomed.querySelector('.iiz__img');
            if (imgElementZoomedTo) {

              if (!imgElementZoomedTo.classList.contains("iiz__zoom-img--visible")) {
                imgElementZoomedTo.classList.add("iiz__zoom-img--visible");

              }
              imgElementZoomedTo.style = this.observedZoomedElementStyle;
            }
            if (imgElementTo) {

              if (!imgElementTo.classList.contains("iiz__img--hidden")) {

                imgElementTo.classList.add("iiz__img--hidden");
              }
            }
          }
        }

      }
    },
    afterZoomOutMethod(imageContainerClassFrom, imageContainerClassTo){


    },
    mainPhotoClick(imageContainerClassFrom, imageContainerClassTo){
      let _this = this;
      setTimeout(()=>{
        const imageContainerZoomedFrom = document.querySelector('.' + imageContainerClassFrom);
        if (imageContainerZoomedFrom) {
        const imgElementZoomedFrom = imageContainerZoomedFrom.querySelector('.iiz__zoom-img');
        const imgElementFrom = imageContainerZoomedFrom.querySelector('.iiz__img');
          if(!imgElementZoomedFrom.classList.contains("iiz__zoom-img--visible")) {

            [imageContainerClassFrom, imageContainerClassTo].forEach((imageContainerClass)=>{

              const imageContainerZoomed = document.querySelector('.' + imageContainerClass);
              const imgElementZoomed = imageContainerZoomed.querySelector('.iiz__zoom-img');
              const imgElement = imageContainerZoomed.querySelector('.iiz__img');

              if (imgElementZoomed) {
                if(imgElementZoomed.classList.contains("iiz__zoom-img--visible")) {
                  imgElementZoomed.classList.remove("iiz__zoom-img--visible");
                }
                _this.observedZoomedElementStyle = _this.observedZoomedElementStyleOld;
                imgElementZoomed.style = _this.observedZoomedElementStyleOld;

              }
              if (imgElement) {
                if(imgElement.classList.contains("iiz__img--hidden")) {
                  imgElement.classList.remove("iiz__img--hidden");
                }
              }
            });
          }
        }
      }, 300);

    },
    zoomImageRatioErase(){
      for( const zoomLevel of this.zoomLevels){
        if('zoom_' + zoomLevel in window){
          if('imgHeight' in window['zoom_' + zoomLevel]){
            delete window['zoom_' + zoomLevel].imgHeight;
          }
          if('imgWidth' in window['zoom_' + zoomLevel]){
            delete  window['zoom_' + zoomLevel].imgWidth ;
          }
        }
      }

    },
    updateComputedValue() {
      this.$nextTick(() => {
        this.$forceUpdate(); // Force the component to re-render and update the computed property
      });
    },
    initSelectImage(){
      const defaultItemForSource = this.fullImageList.find(item => item.type === 'main_photo_before');
      if (defaultItemForSource) {
        this.selectedOptionSource = defaultItemForSource.value;
      }
      const defaultItemForHover = this.fullImageList.find(item => item.type === 'main_photo_after');
      if (defaultItemForHover) {
        this.selectedOptionHover = defaultItemForHover.value;
      }
    },
    initZoom(){
      this.setZoomImage('before');
      this.zoomImageRatioErase();
      this.readAndPreviewZoomImage('main_photo_before');
      this.readAndPreviewZoomImage('main_photo_after');
    }
  },
  async created() {
    this.local_page_keys = await this.$filtergetLocalisationPage('order-photo-block');
    this.local_page_keys_functions = await this.$filtergetLocalisationPage('ru_retoucher_translations');
    this.zoomImageRatioErase();
    this.initSelectImage();
  },
  computed: {
    isLoading() {
      return this.$store.state.loading.isLoading;
    },
    descriptionComputed() {
      if (this.main_photo_before_after_same)
        return 'before';

      if (this.photoAfterVisible && !this.beforeVisible)
        this.setDescription('zone_photo', this.selectedOptionSource);

      if (!this.photoAfterVisible && this.beforeVisible)
        this.setDescription('zone_photo', this.selectedOptionHover);

      return this.description;
    },
    modal_photo_before_zoomed_computed(){
      return this.modal_photo_before_zoomed;
    },
    modal_photo_after_zoomed_computed(){
      return this.modal_photo_after_zoomed;
    },
    tooltipPhotoDownloadHover(){
      return this.parseFileName(this.selectedOptionHover)
    }
  },
  mounted() {
    this.fetchFunctionsClientFile();
    this.initZoom();
  },
  watch: {
    // Watch for changes in asyncData and trigger the computed property update
    modal_photo_before_zoomed_computed: 'updateComputedValue',
    modal_photo_after_zoomed_computed: 'updateComputedValue',
    zoomFactor: 'updateComputedValue',
    selectedOptionSource: function (newVal) {
      if (newVal && newVal !== this.modal_photo_after) {
        this.modal_photo_after = newVal;
        this.initZoom();
      }
    },
    selectedOptionHover: function (newVal) {
      if (newVal && this.selectedOptionSource && newVal !== this.modal_photo_before) {
        this.modal_photo_before = newVal;
        this.initZoom();
      }
    },
    zone_photo: function (newVal) {
      if ( this.zoneVisible && newVal) {
        this.beforeVisible = true
        this.photoAfterVisible = false
        this.modal_photo_before = newVal;
        this.setDescription('zone_photo', newVal)
      } else {
        this.modal_photo_before = this.selectedOptionHover;
      }
      this.initZoom();
    },
    isOutChat: function (newVal, oldVal) {
      if(newVal && !oldVal) {
        this.beforeVisible = false
        this.photoAfterVisible = true
      }
    },
    main_photo_after: function (newVal, oldVal) {
      this.initSelectImage();
    },
    main_photo_before: function (newVal, oldVal) {
      this.initSelectImage();
    }
  },
}
</script>
<style>
@import '../../../assets/css/uikit/subnav.css';
@import '../../../assets/css/uikit/sticky.css';
@import '../../../assets/css/vue-inner-image-zoom.css';
.selector[data-v-2bf22088] {
  border: 4px solid #fff;
}
[class*="_zoomed"].iiz {
  overflow: initial;
}
</style>